export default function getEventShareUrl(config, event) {
  return `${config.custom.platformUrl()}/share/event/${event.id}`;
}
